import { render, staticRenderFns } from "./IFRatios.vue?vue&type=template&id=3c00af7f"
import script from "./IFRatios.vue?vue&type=script&lang=js"
export * from "./IFRatios.vue?vue&type=script&lang=js"
import style0 from "./IFRatios.vue?vue&type=style&index=0&id=3c00af7f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports